import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import CompanyDocumentsDataTable from 'modules/documents/components/CompanyDocumentsDatatable'
import filesStore from 'modules/documents/components/Documents/store'
import Folders from 'modules/documents/components/DocumentsAndFolders/FoldersList'
import DocumentsResourceHeader from 'modules/documents/components/DocumentsResourceHeader'
import { Folder } from 'modules/documents/hooks/useGetFolders'
import { SPACES } from 'modules/documents/lib/constants'

interface Props {
  canUploadDocument: boolean
}

const InternalCompanyDocuments = ({ canUploadDocument }: Props) => {
  const space = SPACES.COMPANY_INTERNAL
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const [folder, setFolder] = useState<Folder>()

  const onDrop = (files: File[], droppedFolder?: Folder) => {
    if (!canUploadDocument) return

    filesStore.concat(files)

    setFolder(droppedFolder)

    navigate(navigation.files.managementDocuments.list.new.fullPath())
  }

  const onUpload = () => {
    setFolder(undefined)

    navigate(navigation.files.managementDocuments.list.new.fullPath())
  }

  const onNavigationClick = (documentId: number) => {
    const documentUrl = navigation.files.managementDocuments.list.documentId.fullPath({
      document_id: documentId,
    })

    navigate(documentUrl)
  }

  const parentRoute = navigation.files.managementDocuments.list.fullPath()

  return (
    <>
      <DocumentsResourceHeader
        title={i18n.t('management_documents.title')}
        canUploadDocument={canUploadDocument}
        url={navigation.files.managementDocuments.list.new.fullPath()}
        removePadding
      />
      <Box paddingTop="s8">
        <Folders space={space} onFolderSelected={setFolder} readonly={!canUploadDocument} />
      </Box>
      <Box paddingTop="s8">
        <CompanyDocumentsDataTable
          folder={null}
          initialFolder={folder}
          parentRoute={parentRoute}
          readonly={!canUploadDocument}
          onDrop={onDrop}
          space={space}
          onNavigationClick={onNavigationClick}
          onUpload={onUpload}
        />
      </Box>
    </>
  )
}

export default observer(InternalCompanyDocuments)
